/* TODO УДАЛИТЬ ПОСЛЕ НАСТРОЙКИ УНИФИЦИРОВАННОЙ ПАГИНАЦИИ */
(function () {
    var selectors = {
        current: '[js-node="pagination__current"]',
        input: '[js-node="pagination__current-input"]'
    };

    var bindUI = function () {
        $(document).on('click', selectors.current, function () {
            showInput($(this).parent());
        });

        $(document).on('keypress', selectors.input, function (e) {
            if (app.inputIsInteger(e) === false) {
                return false;
            }
        })

        $(document).on('blur', selectors.input, function () {
            hideInput($(this).parent());
        });
    };

    var showInput = function (parent) {
        if (parent) {
            parent.addClass('visible-input');
            parent.find(selectors.input).select();
        }
    };

    var hideInput = function (parent) {
        if (parent) {
            parent.removeClass('visible-input');
        }
    };

    $(function () {
        bindUI();
    });
}());